<template>
    <v-dialog v-model="show" max-width="600px">
        <v-toolbar color="#00ba57" dark>
            <v-toolbar-title class="toolbar-title">QR-код</v-toolbar-title>
        </v-toolbar>
        <v-card>
            <v-card-text>
                <v-container>
                    <v-layout row wrap>
                        <v-flex xs12 class="text-center">
                            <qr-code :url="link"></qr-code>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red" flat
                       @click.stop="show = false">Закрыть</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import QrCode from "../../fields/QrCode";

export default {
    name: "QrCodeDialog",
    components: {QrCode},
    props: ['value', 'link'],
    computed: {
        show: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        }
    }
}
</script>

<style scoped>
.toolbar-title {
    font-family: 'SFProBold';
    font-size: 20px;
}

.text-center {
    text-align: center
}
</style>



// WEBPACK FOOTER //
// resources/js/components/b2b/profile/QrCodeDialog.vue